import { Avatar, AvatarFallback, AvatarImage } from '@repo/ui'
import { CircleUserRoundIcon } from 'lucide-react'
import React from 'react'

import { cn } from '../lib'

interface IProps {
  avatarUrl?: string
  className?: string
  size?: string
  style?: React.CSSProperties
}

export const KitAvatar = ({ avatarUrl, className }: IProps) => {
  return (
    <Avatar className={cn('size-10', 'mr-2', className)}>
      <AvatarImage src={avatarUrl} />
      <AvatarFallback>
        <CircleUserRoundIcon className={cn('size-10', className)} />
      </AvatarFallback>
    </Avatar>
  )
}
